import React from "react"

import { Input } from "antd"
import cls from "classname"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import "./styles.less"

const { TextArea } = Input

export const TextAreaComponent = React.forwardRef(({ onChange, className, ...props }, ref) => {
  const isDisabledTransition = useSelector((state) => state.nav.disabledTransition)

  return (
    <TextArea
      onChange={onChange}
      className={cls(className, "input", {
        "disabled-transition": isDisabledTransition
      })}
      ref={ref || null}
      {...props}
    />
  )
})

TextAreaComponent.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string
}

export default TextAreaComponent
